module.exports = __webpack_public_path__ + "img/icon-20-terms.97b37c9c.svg";